<div class="new-teacher-card-mini">
  <div class="top">
    <div class="flag-block">
      <div class="flag-wrap">
        <img *ngIf="countryFlagUrl" [src]="countryFlagUrl" [alt]="countryName" class="flag">
      </div>
    </div>

    <div class="avatar-wrap">
      <on-ui-cover [cover]="cover"></on-ui-cover>
    </div>

    <p class="name">{{ name }}</p>

    <span class="subject-label">{{ 'news.teacher-card.teaches' | customLocale }}</span>

    <span class="subject">
      {{ mainTeachingSubject?.title || '&#4448;' }}
      <span *ngIf="othersSubjectLength" class="subject others">+{{ othersSubjectLength }}</span>
    </span>
  </div>

  <div class="bottom">
    <span class="price-label">{{ 'news.teacher-card.from' | customLocale }}</span>
    <span class="price-value bold">
      {{ minPriceTier ? (getFormattedPrice(minPriceTier) | async) : 0 }}
    </span>
    <span class="price-label">{{ 'news.teacher-card.price' | customLocale }}</span>
  </div>
</div>
